/* eslint-disable no-throw-literal */
import { useCallback } from "react"
import { IOcupacao } from "../../../application/models"
import { useAxiosInstances } from "../../axios-instance"

export const useOcupacaoApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const getOcupacaoBySearchTermApi = useCallback(async (data: {
        searchTerm: string,
        categoria: keyof IOcupacao
    }): Promise<IOcupacao[]> => {
        try {
            const result = await axiosAuthInstance.get('/geo-veles/ocupacao', {
                params: {
                    category: data.categoria,
                    searchTerm: data.searchTerm
                }
            })

            return result.data.ocupacoes
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    return {
        getOcupacaoBySearchTermApi
    }
}